import Reflux from "reflux";

export default {
  beginDrag: Reflux.createAction({ sync: false }),
  endDrag: Reflux.createAction({ sync: false }),
  onDropCatalogInSection: Reflux.createAction({ sync: false })
};
